export default "__VITE_ASSET__TSTUUOv7__"